import { type AppThunk } from "../../../index";
import { unsubscribeFromProducts as action } from "../reducer";
import { closeRealtimeChannel } from "../../../helpers/closeRealtimeChannel";
import { claimRealtimeSlot } from "../../../helpers/realtimeSlot";

export const unsubscribeFromProducts =
  (): AppThunk =>
  async (dispatch, _, { subscriptions, db }) => {
    // take the slot so a subscribe still waiting on its fetch does not resurrect the channel
    claimRealtimeSlot(subscriptions, "products");

    // detach synchronously - awaiting the close first would let a subscribe that
    // already claimed the slot store its channel, only for this thunk to null it out
    const channel = subscriptions.realtimeProductsListChannel;
    subscriptions.realtimeProductsListChannel = null;
    subscriptions.productsListChannelName = null;
    void closeRealtimeChannel(db, channel);
    dispatch(action());
  };
